import React, { useState } from "react";
import { Link } from "react-router-dom";
import bg1 from "../assets/images/Banner_imgs/contactus.jpg";
import {
  FiPhone,
  FiMail,
  FiMapPin,
  IoIosArrowDown,
  IoIosArrowUp,
} from "../assets/icons/vander";
import PageContainer from "../components/container/Container";
import { apiCall } from "../utils/ApiUtil";
import { toast } from "react-toastify";

const servicesOptions = [
  { lable: "OmniScientia", value: "computer_vision" },
  { lable: "Perfectus", value: "test_automation" },
];

export default function Contact() {
  const [selectOpen, setSelectOpen] = useState(false);
  const [error, setErrors] = useState({
    name: "",
    email: "",
    services: "",
    subject: "",
    comments: "",
  });

  const validate = (data) => {
    const { name, email, service, subject, comments } = data;
    let isError = false;
    const errorsCopy = { ...error };

    if (name?.trim() === "") {
      isError = true;
      errorsCopy.name = "Please enter your Name.";
    } else {
      errorsCopy.name = "";
    }
    if (email.trim() === "") {
      isError = true;
      errorsCopy.email = "Please enter your Email.";
    } else {
      errorsCopy.email = "";
    }
    if (service.trim() === "") {
      isError = true;
      errorsCopy.services = "Please select Service you are intested in.";
    } else {
      errorsCopy.services = "";
    }
    if (subject.trim() === "") {
      isError = true;
      errorsCopy.subject = "Please enter Subject.";
    } else {
      errorsCopy.subject = "";
    }
    if (comments.trim() === "") {
      isError = true;
      errorsCopy.comments = "Please enter Comment.";
    } else {
      errorsCopy.comments = "";
    }

    setErrors({ ...errorsCopy });
    return isError;
  };

  const handleformSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;

    const name = form.elements["name"].value;
    const email = form.elements["email"].value;
    const service = form.elements["service"].value;
    const subject = form.elements["subject"].value;
    const comments = form.elements["comments"].value;

    const payload = {
      email,
      action: "storeContactUs",
      data: {
        name,
        service,
        subject,
        comments,
      },
    };

    if (!validate({ name, email, service, subject, comments })) {
      const response = await apiCall(payload);
      if (response?.status === 200 && response?.data?.statusCode === 200) {
        toast.success("Contact Request sent Successfully.");
        form.reset();
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <PageContainer
      title={"Contact Us - CodeElan Technologies"}
      description={
        "Get in touch with CodeElan Technologies. We're here to help you with AI/ML solutions, computer vision, and testing automation."
      }
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    Get In <span className="text-primary">Touch</span>
                  </h1>
                  <p className="hero-subtitle">
                    Ready to transform your business with AI and automation? Let's discuss how we can help you achieve your goals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form & Information Section */}
      <section className="section">
        <div className="container">
          <div className="row">
            {/* Contact Form */}
            <div className="col-lg-8">
              <div className="contact-form-card">
                <h3 className="contact-section-title mb-4">Send Us a Message</h3>
                <p className="contact-form-subtitle mb-4">
                  Fill out the form below and we'll get back to you as soon as possible
                </p>
                
                <form onSubmit={handleformSubmit} className="contact-form">
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <label htmlFor="name" className="form-label">Full Name *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className={`form-control ${error.name ? 'is-invalid' : ''}`}
                          placeholder="Enter your full name"
                        />
                        {error.name && <div className="invalid-feedback">{error.name}</div>}
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <label htmlFor="email" className="form-label">Email Address *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className={`form-control ${error.email ? 'is-invalid' : ''}`}
                          placeholder="Enter your email address"
                        />
                        {error.email && <div className="invalid-feedback">{error.email}</div>}
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <label htmlFor="service" className="form-label">Service Interested In *</label>
                        <select
                          id="service"
                          name="service"
                          className={`form-select ${error.services ? 'is-invalid' : ''}`}
                          onClick={() => setSelectOpen(!selectOpen)}
                        >
                          <option value="">Select a service</option>
                          {servicesOptions.map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.lable}
                            </option>
                          ))}
                        </select>
                        {error.services && <div className="invalid-feedback">{error.services}</div>}
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <label htmlFor="subject" className="form-label">Subject *</label>
                        <input
                          type="text"
                          id="subject"
                          name="subject"
                          className={`form-control ${error.subject ? 'is-invalid' : ''}`}
                          placeholder="Enter subject"
                        />
                        {error.subject && <div className="invalid-feedback">{error.subject}</div>}
                      </div>
                    </div>
                  </div>
                  
                  <div className="form-group mb-4">
                    <label htmlFor="comments" className="form-label">Message *</label>
                    <textarea
                      id="comments"
                      name="comments"
                      rows="5"
                      className={`form-control ${error.comments ? 'is-invalid' : ''}`}
                      placeholder="Tell us about your project or requirements"
                    ></textarea>
                    {error.comments && <div className="invalid-feedback">{error.comments}</div>}
                  </div>
                  
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary btn-lg">
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
            
            {/* Contact Information */}
            <div className="col-lg-4">
              <div className="contact-info-section">
                <h3 className="contact-section-title mb-4">Contact Information</h3>
                <div className="contact-cards">
                  <div className="contact-card mb-4">
                    <div className="contact-icon">
                      <FiPhone />
                    </div>
                    <h4 className="contact-title">Phone</h4>
                    <p className="contact-info">+91-8208650598</p>
                  </div>
                  <div className="contact-card mb-4">
                    <div className="contact-icon">
                      <FiMail />
                    </div>
                    <h4 className="contact-title">Email</h4>
                    <p className="contact-info">info@codeelan.com</p>
                  </div>
                  <div className="contact-card mb-4">
                    <div className="contact-icon">
                      <FiMapPin />
                    </div>
                    <h4 className="contact-title">Location</h4>
                    <p className="contact-info">India</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}
